module.exports = __webpack_public_path__ + "frontend/img/icon-receive-money-xs.c91a26a3.svg";